<template>
  <Questions @cancel="cancelTest"  />
</template>

<script>
import { mapState } from "vuex";
import Questions from "./questions";
export default {
  data() {
    return {
      
    }
  },
  components: {
    Questions
  },
  computed: {
    ...mapState("employee", ["employee"])
  },
  methods: {
    cancelTest() {
      this.$router.push("/profile");
    }
  }
};
</script>

<style></style>
